import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { TICKET_MASSIVE_POSTPONE_TYPE_OPTIONS } from '../../../../config/constants';
import ItinerarySearchInput from '../../../common/forms/input/ItinerarySearchInput';
import FormItem from '../../../common/forms/FormItem';
import Select from '../../../common/forms/select/Select';
import { isRequired } from '../../../../utils/validators';
import FormFooter from '../../../common/forms/FormFooter';

const TicketMassivePostponeSearchForm = ({
  handleSubmit,
  onSubmit,
  handleSelectItinerary,
  handleShowItinerarySearch,
  handleClear,
  handleTypeChange,
}) => {
  const typeOptions = Object.keys(TICKET_MASSIVE_POSTPONE_TYPE_OPTIONS).map(
    (key) => ({
      value: TICKET_MASSIVE_POSTPONE_TYPE_OPTIONS[key].value,
      label: TICKET_MASSIVE_POSTPONE_TYPE_OPTIONS[key].label,
    }),
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup row>
        <FormItem label="Itinerario">
          <Field
            name="itineraryId"
            component={ItinerarySearchInput}
            placeholder="Itinerario"
            handleSelectItinerary={handleSelectItinerary}
            handleShowItinerarySearch={handleShowItinerarySearch}
            handleClear={handleClear}
            props={{ form: 'TicketMassivePostponeSearchForm' }}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Tipo" required>
          <Field
            name="type"
            component={Select}
            options={typeOptions}
            placeholder="Tipo"
            validate={[isRequired]}
            onChange={handleTypeChange}
          />
        </FormItem>
      </FormGroup>

      <FormFooter saveButtonText="Buscar" saveButtonIcon="fa fa-search" />
    </form>
  );
};

TicketMassivePostponeSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,

  handleSelectItinerary: PropTypes.func,
  handleShowItinerarySearch: PropTypes.func,
  handleClear: PropTypes.func,
  handleTypeChange: PropTypes.func,
};

TicketMassivePostponeSearchForm.defaultProps = {
  handleSelectItinerary: undefined,
  handleShowItinerarySearch: undefined,
  handleClear: undefined,
  handleTypeChange: undefined,
};

const mapStateToProps = (state) => ({
  itineraryCounter:
    state.ItineraryUnit.Itinerary.getIn(['current', 'content']) || undefined,
});

const formComponent = reduxForm({
  form: 'TicketMassivePostponeSearchForm',
})(TicketMassivePostponeSearchForm);

export default connect(mapStateToProps, null)(formComponent);
